import { createContext } from 'react';
import { ToastNotificationsControlContextType } from './types';

export const ToastNotificationsControlContext = createContext<ToastNotificationsControlContextType>(
  {
    showNotification: () => {},
  } as ToastNotificationsControlContextType,
);
